import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, X } from "lucide-react";

const DISMISS_KEY = "arcana-safety-banner";

export const SafetyBanner = () => {
  const [visible, setVisible] = useState(() => localStorage.getItem(DISMISS_KEY) !== "closed");

  if (!visible) return null;

  const close = () => {
    localStorage.setItem(DISMISS_KEY, "closed");
    setVisible(false);
  };

  return (
    <section className="px-4 pt-8" data-testid="safety-banner">
      <div className="relative max-w-2xl mx-auto rounded-2xl border border-amber-500/40 bg-[#180a26] px-6 py-6 shadow-[0_0_40px_rgba(74,33,117,0.35)]">
        <button
          onClick={close}
          data-testid="safety-banner-close"
          aria-label="Chiudi avviso"
          className="absolute top-3 right-3 text-purple-300/50 hover:text-amber-200 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 shrink-0 rounded-full border border-amber-500/40 bg-[#1a0b2b] flex items-center justify-center shadow-[0_0_18px_rgba(212,175,55,0.25)]">
            <ShieldCheck className="w-5 h-5 text-amber-300" />
          </div>
          <h2 className="font-display text-lg sm:text-xl text-amber-100">La tua serenità viene prima di ogni carta</h2>
        </div>
        <p className="text-purple-100/80 text-sm leading-relaxed mt-4">
          In Arcana la salute e la sicurezza di chi consulta vengono prima di tutto. Se una lettura tocca temi di salute, vedrai sempre un promemoria che ti invita a parlarne con il tuo medico: le carte sono uno strumento di riflessione, mai una diagnosi. E se le carte dovessero parlare di una situazione che può fare male, ti mostreremo subito i contatti di chi può aiutarti davvero: <span className="text-amber-300 font-medium">112</span> (emergenze), <span className="text-amber-300 font-medium">1522</span> (antiviolenza e stalking), <span className="text-amber-300 font-medium">114</span> (emergenza infanzia).
        </p>
        <p className="text-purple-200/70 text-sm italic leading-relaxed mt-3">
          Perché il nostro primo dovere è prenderci cura di te, dentro e fuori le carte.
        </p>
        <Link
          to="/disclaimer"
          data-testid="safety-banner-disclaimer-link"
          className="inline-block mt-4 text-xs text-amber-300/90 tracking-wide underline underline-offset-4 decoration-amber-500/40 hover:text-amber-200 transition-colors"
        >
          Leggi il disclaimer completo
        </Link>
      </div>
    </section>
  );
};
